module.exports = __webpack_public_path__ + "static/media/internship1.f3a874a9.png";